// Helpers de data/semana centralizados. Importar daqui, não redefinir por arquivo.

export function isoDate(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function weekStartISO(d: Date): string {
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(d);
  monday.setDate(d.getDate() + diff);
  return isoDate(monday);
}

export function dateDiffDays(from: string | null | undefined, to: string | null | undefined): number | null {
  if (!from || !to) return null;
  const start = new Date(`${from.slice(0, 10)}T00:00:00`).getTime();
  const end = new Date(`${to.slice(0, 10)}T00:00:00`).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end)) return null;
  return Math.round((end - start) / 86_400_000);
}

export function addDaysISO(value: string, days: number): string {
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return isoDate(date);
}

export function getCurrentMonthRange(): { from: string; to: string } {
  const now = new Date();
  return {
    from: isoDate(new Date(now.getFullYear(), now.getMonth(), 1)),
    to: isoDate(now),
  };
}

export function endOfDefaultProjection(todayIso: string): string {
  const [year, month] = todayIso.split('-').map(Number);
  return isoDate(new Date(year, month + 3, 0));
}

export function resolveDefaultRangeEnd(todayIso: string, weekStarts: string[]): string {
  const futureEnds = weekStarts
    .map(wk => addDaysISO(wk, 6))
    .filter(end => end >= todayIso)
    .sort();
  return futureEnds[futureEnds.length - 1] ?? endOfDefaultProjection(todayIso);
}

export function computeWeekRangeLabel(wkStr: string): string {
  const start = new Date(wkStr + 'T00:00:00');
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  const d1 = `${String(start.getDate()).padStart(2, '0')}/${String(start.getMonth() + 1).padStart(2, '0')}`;
  const d2 = `${String(end.getDate()).padStart(2, '0')}/${String(end.getMonth() + 1).padStart(2, '0')}`;
  const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  return `${d1} a ${d2} (${months[start.getMonth()]})`;
}

export function computeMesLabel(wkStr: string): string {
  const d = new Date(wkStr + 'T00:00:00');
  return d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
}

export function computeSemanaDoMes(wkStr: string): number {
  return Math.ceil(new Date(wkStr + 'T00:00:00').getDate() / 7);
}

export function countMondaysInMonth(ym: string): number {
  const [year, month] = ym.split('-').map(Number);
  const lastDay = new Date(year, month, 0).getDate();
  let count = 0;
  for (let d = 1; d <= lastDay; d++) {
    if (new Date(year, month - 1, d).getDay() === 1) count++;
  }
  return count || 4;
}

export function getDefaultMonths(): string[] {
  const now = new Date();
  return Array.from({ length: 6 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    return isoDate(d).slice(0, 7);
  });
}
